// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MuiInputBase-input {\n    font-size: 15px !important;\n}\n\n.llAOrU {\n    min-height: 270px !important\n}", "",{"version":3,"sources":["webpack://src/google-translation/child.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;AAC9B;;AAEA;IACI;AACJ","sourcesContent":[".MuiInputBase-input {\n    font-size: 15px !important;\n}\n\n.llAOrU {\n    min-height: 270px !important\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
